import React from 'react';
import clsx from 'clsx';

import {Snackbar, SnackbarContent} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';

import styles from './MainSnackbar.module.css';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};


export interface Props {
  className?: string;
  open: boolean;
  message?: string;
  onClose?: () => void;
  variant: keyof typeof variantIcon;
}

function MainSnackbar(props: Props) {
  const {className, message, onClose, variant, ...other} = props;
  const Icon = variantIcon[variant];

  return (
    <Snackbar
      className={styles.body}
      open={props.open}
      onClose={props.onClose}
      autoHideDuration={6000}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
    >
      <SnackbarContent
        className={clsx(styles.body, styles[variant], className)}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={styles.message}>
            <Icon className={clsx(styles.icon, styles.iconVariant)}/>
            {message}
          </span>
        }
        {...other}
      />
    </Snackbar>
  );
}

export default MainSnackbar